import IframeActivity from "./IframeActivity";

export default function WhatTimeShouldIGetUp() {
    return (
        <IframeActivity
            src="/activities/what-time-should-i-get-up/index.html"
            title="What Time Should I Get Up?"
        />
    );
}